<script setup lang="ts">
import MobileNavigation from '~/components/navigation/MobileNavigation.vue'
import MobileContextualNavigation from '~/components/mobile/MobileContextualNavigation.vue'
import WwwNavigation from '~/components/WwwNavigation.vue'
import SourceNavigation from '~/components/navigation/SourceNavigation.vue'
import { useSourceNavigation } from '~/composables/useSourceNavigation'

const { levelTwoExists } = useSourceNavigation()
const { $auth, $config, $modal } = useNuxtApp()

const headerSourceLogoHeight = 65
let prevScrollPos = 0
const ELEMENT_ID = {
  DESKTOP: 'header-desktop',
  MOBILE: 'header-mobile',
}

const onScrollHideOrShow = (elId: string, elHeight: number = 0) => {
  const currentScrollPos = window.scrollY
  const navbar = document.getElementById(elId)

  if (!navbar) return

  if (elHeight === 0) elHeight = navbar.offsetHeight

  navbar.style.translate = '0px'

  if (!(prevScrollPos < currentScrollPos && currentScrollPos > elHeight)) {
    if (prevScrollPos > currentScrollPos) {
      navbar.style.translate = '0px'
    }
  } else {
    navbar.style.translate = `0 -${elHeight}px`
  }
  prevScrollPos = currentScrollPos
}

onMounted(() => {
  window.addEventListener('scroll', () => {
    if (window.innerWidth >= 1280) {
      onScrollHideOrShow(ELEMENT_ID.DESKTOP, headerSourceLogoHeight)
    } else {
      onScrollHideOrShow(ELEMENT_ID.MOBILE)
    }
  })
})
</script>

<template>
  <div class="main-layout grid min-h-svh w-full flex-col">
    <div
      :id="ELEMENT_ID.DESKTOP"
      class="transition-translate fixed z-50 mt-10 hidden w-full bg-white header-breakpoint:block"
    >
      <WwwNavigation />
      <SourceNavigation />
    </div>
    <div :id="ELEMENT_ID.MOBILE" class="transition-translate fixed z-50 w-full">
      <TheTicker class="hidden w-full md:block" />
      <MobileNavigation class="header-breakpoint:hidden" />
      <MobileContextualNavigation class="header-breakpoint:hidden" />
    </div>

    <main
      class="mt-[45px] flex grow flex-col md:mt-[80px] header-breakpoint:mt-[149px]"
      :class="
        levelTwoExists &&
        'mt-[85px] md:mt-[120px] header-breakpoint:mt-[212.65px]'
      "
    >
      <div
        v-if="$config.public.isPreviewSite && !$auth.store.canPreviewContent"
        class="mx-auto flex max-w-md grow flex-col justify-center px-5 text-center"
      >
        <div>
          <button
            data-testid="login-button"
            class="underline"
            @click.prevent="$modal.open('login')"
          >
            Login
          </button>
          with an author, editor, or administrator account to see the content
          preview.
        </div>
      </div>

      <slot v-else />
    </main>

    <TheFooter />

    <ButtonRequestATrial />
    <ModalLightbox name="imageLightbox" data-testid="image-lightbox-modal" />
    <ModalExpiredTrial />
    <ModalNoSourceSubscription />
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.15s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

.transition-translate {
  transition: translate 0.3s ease;
}

.main-layout {
  grid-template-rows: minmax(0, max-content) 1fr minmax(0, max-content);
}
</style>
